import(/* webpackMode: "eager" */ "/app/apps/frontend/src/app/error.tsx");
